<template>
  <div class="w-dialog">
    <transition name="mask">
      <div class="mask" v-show="dialogState" @click="handleClose"></div>
    </transition>
    <transition name="alert">
      <div class="w-dialog-content" :class="{'reset-dialog-content': dialogContentData.isSetOnlineCv}" v-show="dialogState" :style="{top: `${top}%`}">
        <i class="iconfont iconx" v-if="options.showCloseIcon" @click="handleClose"></i>
        <p class="title">{{ dialogContentData.title }}</p>
        <p class="content" v-html="dialogContentData.content" v-if="!dialogContentData.isSetOnlineCv"></p>
        <div class="set-online-content" v-else>
          <div class="item">
            <div class="point" />
            <span>已达优秀简历标准，正优先推荐至 HR</span>
          </div>
          <div class="item">
            <div class="point" />
            <span>可在【设置】选择屏蔽公司/关闭推荐</span>
          </div>
          <div class="item active">
            <div class="point" />
            <span>开启直接联系：允许HR主动与你交换联系方式，不在错过重要机会</span>
          </div>
        </div>
        <div class="dialog-buttons">
          <button class="cancel-btn" :class="{'reset-canel-btn': dialogContentData.isSetOnlineCv}" v-if="dialogContentData.cancelText" @click="dialogContentData.cancelFn && dialogContentData.cancelFn()">{{ dialogContentData.cancelText }}</button>
          <button class="confirm-btn" v-if="dialogContentData.confirmText" @click="dialogContentData.confirmFn && dialogContentData.confirmFn()">{{ dialogContentData.confirmText }}</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      dialogState: {
        type: Boolean,
        default: false
      },
      top: {
        type: [String, Number],
        default: 15
      },
      dialogContentData: {
        type: Object,
        default: () => {
          return {
            title: '提示',
            content: '',
            confirmText: '确定',
            cancelText: '取消',
            confirmFn: () => {},
            cancelFn: () => {},
          }
        }
      },
      options: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {}
    },
    components: {},
    watch: {},
    computed: {},
    methods: {
      handleClose () {
        this.$emit('handleClose')
      }
    }
  }
</script>
<style scoped lang="scss">
  .w-dialog {
    display: flex;
    justify-content: center;
    .mask-enter-active,
    .mask-leave-active {
      transition: all 0.3s;
    }
    .mask-enter,
    .mask-leave-to {
      opacity: 1;
    }
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 119;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: all 0.3s;
    }

    .fade-enter,
    .fade-leave-to {
      transform: translate3d(0, -150%, 0);
    }

    .reset-dialog-content {
      border-radius: 4px;
    }

    .w-dialog-content {
      position: fixed;
      top: 15%;
      // left: 50%;
      // transform: translateX(-50%);
      z-index: 121;
      min-width: 446px;
      background-color: #ffffff;
      border-radius: 8px;
      padding: 32px 32px 24px;
      box-shadow: 0 0 10px 0 rgba($color: #060443, $alpha: .1);
      .title {
        color: #404040;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        margin-bottom: 12px;
      }
      .content {
        color: #606060;
        line-height: 24px;
        margin-bottom: 26px;
      }
      .dialog-buttons {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .button-publish {
          display: flex;
          justify-content: center;
          align-items: center;
          outline: none;
          padding: 0 24px;
          height: 36px;
          border-radius: 4px;
        }
        .confirm-btn {
          @extend .button-publish;
          background-color: #FF6644;
          color: #ffffff;
          margin-left: 16px;
        }
        .cancel-btn {
          @extend .button-publish;
          border: 1px solid #CFCFCF;
          color: #606060;
          background-color: #FFffff;
        }
        .reset-canel-btn {
          @extend .button-publish;
          border-color: #ff6644;
          color: #FF6644;
          background-color: #FFffff;
        }
      }
      .iconx {
        position: absolute;
        top: 32px;
        right: 32px;
        font-size: 18px;
        cursor: pointer;
        color: #404040;
      }
    }

    .reset-dialog-content {
      border-radius: 4px;
      padding: 32px 28px 24px;
      box-sizing: border-box;
      .set-online-content {
        //color: #000;
        //line-height: 24px;
        margin-bottom: 26px;
        .item {
          display: flex;
          align-items: center;
          height: 24px;
          .point {
            width: 5px;
            height: 5px;
            background-color: #404040;
            border-radius: 50%;
            margin-right: 12px;
          }
          span {
            color: #606060;
            font-size: 14px;
          }
        }
        .active {
          .point {
            background-color: #ff6644;
          }
          span {
            color: #ff6644;
          }
        }

      }
    }
  }
</style>
